import ident from "$images/Ident.svg";
import macDent from "$images/Macdent.svg";
import email from "$images/Mail.svg";
import telegram from "$images/TG.svg";
import amoCrm from "$images/Amo.svg";
import metric from "$images/Metrica.svg";
import webSite from "$images/Site.svg";
import dentalPro from "$images/DentalPro.svg";
import externalLink from "$images/ExternalLink.svg";
import google from "$images/google.svg";
import max from "$images/max.svg";
import type {
  stateIntegration,
  integrationList,
  sortIntegration,
  integratioObj,
  integrationItem
} from "@/page/setting/integration/IntegrationTypes";
import envybox from "$images/Envybox.svg";
import {defineStore} from "pinia";
import {API} from "@/api/generated";

function getClassStatus(key: string, data: integrationItem | string): boolean {
  let arr = [];
  if (typeof data === "string") {
    arr.push(data);
  } else {
    switch (key) {
      case "ident":
        if ("id" in data) {
          arr.push(data?.id);
        }
        break;
      case "macDent":
        if ("id" in data) {
          arr.push(data?.id);
        }
        break;
      case "telegram":
      case "max":
        if ("id" in data && "name" in data) {
          arr.push(data?.id, data?.name);
        }
        break;
      case "metric":
        if ("id" in data) {
          arr.push(data?.id);
        }
        break;
      case "amoCrm":
        if ("mainPipelines" in data && "mainStatus" in data) {
          arr.push(data?.mainPipelines, data?.mainStatus);
        }
        break;
      case "dentalPro":
        if ("token" in data && "secret" in data) {
          arr.push(data.token, data.secret);
        }
        break;
      case "webSite":
        arr.push(data);
        break;
    }
  }

  let newArr = arr.filter((item) => Boolean(item));
  if (arr.length !== newArr.length) {
    return false;
  }
  return true;
}

async function getInfoDomain(
  domain: string
): Promise<{ip?: boolean; ssl?: boolean} | false> {
  return await API.checkDomain({body: {domain}});
}

export const useIntegrationStore = defineStore("integrationData", {
  state: (): stateIntegration => ({
    sortIntegrationsObject: "await",
    categoryList: ["Все", "МИС", "Уведомления", "Аналитика", "Другое"],
    integration: {
      ident: {
        logo: ident,
        category: "МИС",
        open: null,
        integration: [],
        keysToAdd: ["name", "id"],
        description:
          "IDENT — это программа для автоматизации бизнес-процессов в стоматологических клиниках."
      },
      macDent: {
        logo: macDent,
        category: "МИС",
        open: null,
        integration: [],
        keysToAdd: ["name", "id"],
        description:
          "MacDent — это облачный сервис для автоматизации работы стоматологических клиник."
      },
      dentalPro: {
        logo: dentalPro,
        category: "МИС",
        open: null,
        integration: [],
        keysToAdd: ["name", "token", "secret"],
        description:
          "DentalPRO — это медицинская информационная система (МИС) для стоматологий. Комплекс программ позволяет настроить функциональность под запросы разных клиник — от небольших кабинетов до крупных сетей."
      },
      email: {
        logo: email,
        category: "Уведомления",
        open: null,
        integration: [],
        keysToAdd: ["email"],
        description:
          "Электронная почта — это сервис или технология, благодаря которой пользователи могут обмениваться сообщениями (электронными письмами) по компьютерной сети."
      },
      telegram: {
        logo: telegram,
        category: "Уведомления",
        open: null,
        integration: [],
        keysToAdd: ["name", "id"],
        description:
          "Telegram — это кроссплатформенная система мгновенного обмена сообщениями (мессенджер)."
      },
      max: {
        logo: max,
        category: "Уведомления",
        open: null,
        integration: [],
        keysToAdd: ["name", "id"],
        description:
          "MAX — кроссплатформенный сервис мгновенного обмена сообщениями."
      },
      amoCrm: {
        logo: amoCrm,
        category: "Уведомления",
        open: null,
        integration: [],
        keysToAdd: [],
        description:
          "AmoCRM — это система управления взаимоотношениями с клиентами, позволяющая автоматизировать продажи и организовать работу отдела маркетинга внутри небольшого предприятия"
      },
      bitrixCrm: {
        logo: webSite,
        category: "Уведомления",
        open: null,
        integration: [],
        keysToAdd: ["name", "webhook", "nameApplication"],
        description:
          "Bitrix24 — CRM-система для обработки лидов и заявок. Интеграция отправляет заявки в CRM через входящий webhook."
      },
      metric: {
        logo: metric,
        category: "Аналитика",
        open: null,
        integration: [],
        keysToAdd: ["id"],
        description:
          "«Яндекс Метрика» — это бесплатный сервис от компании Яндекс, предназначенный для сбора и анализа данных о посещаемости сайтов"
      },
      webSite: {
        logo: webSite,
        category: "Другое",
        open: null,
        integration: [],
        keysToAdd: ["domain"],
        description:
          "Веб-сайт — это совокупность взаимосвязанных веб-страниц, размещенных под одним доменным именем в интернете"
      },
      externalLink: {
        logo: externalLink,
        category: "Другое",
        open: null,
        integration: []
      },
      google: {
        logo: google,
        category: "Другое",
        open: null,
        integration: [],
        keysToAdd: [],
        description:
          "Google Sheets — онлайн-редактор электронных таблиц от Google. Это бесплатная программа, которая интегрирована с другими сервисами Google и позволяет хранить данные в облаке."
      },
      domain: {
        logo: externalLink,
        category: "Другое",
        open: null,
        info: {ip: false, ssl: false},
        keysToAdd: ["domain"],
        integration: []
      },
      cbkiller: {
        logo: envybox,
        category: "Другое",
        open: null,
        integration: [],
        keysToAdd: ["id"],
        description:
          "CallbackKILLER — набор сервисов для повышения конверсии сайта и увеличения продаж"
      }
    }
  }),

  actions: {
    async fetchIntegrations(integration: integratioObj | null): Promise<void> {
      const resolvedIntegration = integration ?? (await API.getIntegration());

      const integrationList = this.integration;
      const keys = [
        "externalLink",
        "email",
        "telegram",
        "max",
        "webSite",
        "ident",
        "macDent",
        "metric",
        "amoCrm",
        "bitrixCrm",
        "dentalPro",
        "google",
        "domain",
        "cbkiller"
      ] as const;
      for (const key of keys) {
        if (key === "domain") {
          const domain = resolvedIntegration[key]?.[0];

          const info =
            typeof domain === "string" && domain.length > 0
              ? await getInfoDomain(domain)
              : false;

          integrationList[key].info =
            info === false ? {ip: false, ssl: false} : info;
        }

        integrationList[key].integration = resolvedIntegration[key] ?? [];
      }

      this.sortIntegrations(integrationList);
      this.updateIntegration(integrationList);
    },

    updateIntegration(integration: integrationList): void {
      this.integration = integration;
    },

    sortIntegrations(integration: integrationList): void {
      this.sortIntegrationsObject = "await";
      let arr = Object.entries(integration);

      arr = arr.filter((a) => {
        return a[1].integration.length > 0;
      });
      if (arr.length === 0) {
        return;
      }

      let sortArr: sortIntegration[] = [];

      arr.forEach(([name, integrationData]) => {
        if (integrationData?.integration?.length > 0) {
          integrationData.integration.forEach((data, num) => {
            const classiIntegration = getClassStatus(name, data);
            if (classiIntegration === false) {
              sortArr.push([
                name,
                {...integrationData, integration: [data], num}
              ]);
            } else {
              sortArr.unshift([
                name,
                {...integrationData, integration: [data], num}
              ]);
            }
          });
        }
      });
      if (this.sortIntegrationsObject === "await") {
        this.sortIntegrationsObject = [];
      }

      sortArr.forEach((element) => {
        if (typeof this.sortIntegrationsObject === "string") {
          return;
        }
        let index = this.sortIntegrationsObject.find((el) => {
          return JSON.stringify(element) === JSON.stringify(el);
        });
        if (!index) {
          let indexCopy = this.sortIntegrationsObject.findIndex((el) => {
            return element[0] === el[0] && element[1].num === el[1].num;
          });
          if (indexCopy >= 0) {
            this.sortIntegrationsObject[indexCopy][1].integration =
              element[1].integration;
          } else {
            this.sortIntegrationsObject.push(element);
          }
        }
      });
    }
  },
  getters: {
    getIntegration: (state: stateIntegration): integrationList => {
      return state.integration;
    },
    getIntegrationName: (state: stateIntegration): string[] => {
      return Object.keys(state.integration).filter(
        (key) => key !== "externalLink"
      );
    },
    getCategoryList: (state: stateIntegration): string[] => {
      return state.categoryList;
    },
    getSortIntegrations: (
      state: stateIntegration
    ): string | sortIntegration[] => {
      return state.sortIntegrationsObject;
    }
  }
});
